import { BIND_TEMPLATE, CREATE_AND_BIND_TEMPLATE, CREATE_TEMPLATE, PARK_SKYFIRE_METHOD, TEMPLATE_RENDERED, } from '../actions';
import Performance from '../utils/performance';
const getTemplateId = (action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return (((_d = (_c = (_b = (_a = action) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.template) === null || _c === void 0 ? void 0 : _c.innerTemplate) === null || _d === void 0 ? void 0 : _d.id) || ((_g = (_f = (_e = action) === null || _e === void 0 ? void 0 : _e.payload) === null || _f === void 0 ? void 0 : _f.template) === null || _g === void 0 ? void 0 : _g.id) || ((_m = (_l = (_k = (_j = (_h = action) === null || _h === void 0 ? void 0 : _h.payload) === null || _j === void 0 ? void 0 : _j.method) === null || _k === void 0 ? void 0 : _k.template) === null || _l === void 0 ? void 0 : _l.innerTemplate) === null || _m === void 0 ? void 0 : _m.id));
};
const getDeeplink = (action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return (((_e = (_d = (_c = (_b = (_a = action) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.template) === null || _c === void 0 ? void 0 : _c.innerTemplate) === null || _d === void 0 ? void 0 : _d.templateData) === null || _e === void 0 ? void 0 : _e.deeplink) || ((_j = (_h = (_g = (_f = action) === null || _f === void 0 ? void 0 : _f.payload) === null || _g === void 0 ? void 0 : _g.template) === null || _h === void 0 ? void 0 : _h.templateData) === null || _j === void 0 ? void 0 : _j.deeplink));
};
export const PagePerformanceMiddleware = (store) => (next) => (action) => {
    next(action);
    const templateId = getTemplateId(action);
    const deeplink = getDeeplink(action) || '';
    switch (action.type) {
        case CREATE_TEMPLATE:
            if (templateId) {
                Performance.mark(`request:${templateId}`);
            }
            break;
        case CREATE_AND_BIND_TEMPLATE:
            if (templateId) {
                // Same logic as CREATE_TEMPLATE
                Performance.mark(`request:${templateId}`);
                // Same logic as BIND_TEMPLATE
                Performance.mark(`request:done:${templateId}`);
                Performance.mark(`render:${templateId}`);
            }
            break;
        case BIND_TEMPLATE:
            if (templateId) {
                Performance.mark(`request:done:${templateId}`);
                Performance.mark(`render:${templateId}`);
            }
            break;
        case PARK_SKYFIRE_METHOD:
            if (templateId) {
                Performance.clearMarks(`request:${templateId}`);
                Performance.clearMarks(`request:done:${templateId}`);
                Performance.clearMarks(`render:${templateId}`);
            }
            break;
        case TEMPLATE_RENDERED:
            if (templateId) {
                if (Performance.hasMark(`render:${templateId}`)) {
                    const id = templateId.split('_').pop();
                    Performance.measure(`page:${id}`, `request:${templateId}`);
                    Performance.measure(`render:${id}`, `render:${templateId}`);
                    Performance.measure(`request:${id}`, `request:${templateId}`, `request:done:${templateId}`);
                    const pageEntry = Performance.getEntriesByName(`page:${id}`).pop();
                    const renderEntry = Performance.getEntriesByName(`render:${id}`).pop();
                    const requestEntry = Performance.getEntriesByName(`request:${id}`).pop();
                    if (renderEntry !== undefined && pageEntry !== undefined) {
                        window.sessionStorage.setItem(templateId, String(Math.round(pageEntry.duration)));
                    }
                    if (pageEntry && renderEntry && requestEntry) {
                        const summary = {
                            page: pageEntry,
                            render: renderEntry,
                            request: requestEntry,
                        };
                        Performance.reportPageLatency(summary, deeplink, store.getState().Authentication);
                        Performance.clearMeasures();
                    }
                }
            }
            break;
    }
};
